<template>
  <router-link
    tag="li"
    class="app-sidebar__nav__dropdown"
    :to="url"
    disabled
  >
    <div
      class="nav-dropdown-toggle"
      @click="handleClick"
    >
      <OptimizerIcon
        :type="icon"
        :class="icon"
      /> {{ name }}
      <b-badge
        v-if="badge"
        class="ml-1"
        :variant="badge.variant"
        ref="badgeContainer"
      >
        {{ badge.text }}
      </b-badge>
      <b-icon icon="chevron-down" />
    </div>
    <ul class="app-sidebar__nav__dropdown__items">
      <slot />
    </ul>
  </router-link>
</template>

<script>
import OptimizerIcon from '@sh/components/Utils/OptimizerIcon.ts.vue';

export default {
  components: {
    OptimizerIcon,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    badge: {
      type: Object,
      required: false,
    },
  },
  methods: {
    handleClick(event) {
      event.preventDefault();

      if (this.$refs.badgeContainer?.contains(event.target)) {
        event.target.parentElement.parentElement.classList.toggle('open');
      } else {
        event.target.parentElement.classList.toggle('open');
      }
    },
  },
};
</script>
